<template>
    <!-- Première cellule vide pour la colonne fixe -->
    <div class="p-2 bg-white" :style="{ gridColumn: `span 1` }"></div>
  
    <!-- Pour chaque jour, pour chaque heure générée, on affichera l'heure avec un fond conditionnel -->
    <template v-for="(year, yIndex) in dateArrays.years" :key="'year-' + yIndex">
      <div 
        @click="go_to(year.startDate)"
        :class="[
          'bg-[#1E1017] text-white rounded-2xl p-1 mb-1 truncate h-8 select-none cursor-pointer hover:bg-[#E8535D]',
          { 'ml-1': yIndex !== 0 }
        ]"
        :style="{ gridColumn: `span ${yearSpan(year)}` }"
      >
        {{ formatYear(year) }}
      </div>
    </template>
      
  </template>
  
  <script>
  
  import { inject } from 'vue';

  export default{
    props:{
      slotsLength: Number,
    },
    setup(){
      const dateArrays = inject('dateArrays');
      const state = inject('state');
      const checkForViewChange = inject('checkForViewChange');
      return { dateArrays, state, checkForViewChange };
    },
    methods:{
      yearSpan(year){
        return (this.slotsLength * year.days);
      },
      formatYear(year) {
        return year.number;
      },
      go_to(date){
        this.state.startDate = new Date(date);
        this.state.endDate = new Date(new Date(date).setDate(new Date(date).getDate() + 368));
        this.checkForViewChange()
      }
    },
  }
  
  </script>